import React, { useState } from "react";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";
import PageHeader from "../../components/PageHeader";
import DataComponent from "../../components/DataComponent";
import { remove } from "lodash-es";

const TestCheckboxAndRadio = (props) => {
  const [selectedCheckbox, setSelectedCheckbox] = useState(false)
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])

  const checkboxes = [
    "체크1",
    "체크2",
    "체크3",
    "체크4",
    "체크5",
  ]
  return (
    <div className="test-page">
      <PageHeader title="WeCake - Checkbox And Radio" />

      <Card>
        <CardBody>
          <CardTitle>Checkbox Single</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            체크박스 한개 사용 예시
          </CardSubtitle>
          <br />

          <div className="badge-items">
            <DataComponent field={{
              type: "checkbox",
              checked: selectedCheckbox === 'testCheck',
              value: 'testCheck',
              onChange: (checked, value) => {
                setSelectedCheckbox(!checked ? false : 'testCheck')
              }
            }}
            />&nbsp;
            {selectedCheckbox ? 'true' : 'false'}
          </div>
          <br />


        </CardBody>
      </Card>
      <br />
      <Card>
        <CardBody>
          <CardTitle>Checkbox Multi</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            체크박스 여러개 사용 예시
          </CardSubtitle>
          <br />

          <div className="badge-items">
            선택된 값 : {selectedCheckboxes.join(',')}
            <br />
            <br />
            {checkboxes.map((checkValue, idx) => {
              return <React.Fragment key={idx}>
                <DataComponent field={{
                  type: "checkbox",
                  checked: selectedCheckboxes.includes(checkValue),
                  value: checkValue,
                  onChange: (checked, value) => {
                    let _selectedCheckboxes = []
                    if (checked) {
                      _selectedCheckboxes = [
                        ...selectedCheckboxes,
                        value
                      ]
                    } else {
                      _selectedCheckboxes = remove(selectedCheckboxes, (v) => v !== value)
                    }
                    setSelectedCheckboxes(_selectedCheckboxes)
                  },
                  label: checkValue
                }}
                />
                &nbsp;&nbsp;
              </React.Fragment>
            })}
          </div>
          <br />


        </CardBody>
      </Card>


    </div>
  );
};

export default TestCheckboxAndRadio;
